import React from "react";
import styled, { css } from "styled-components";
import Flex from "../../Layout/Flex";
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1rx0r8w-0"
})(["", ""], ({
  vertical
}) => !vertical && css(["display:flex;align-items:center;height:42px;"]));
const StyledLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "StyledLabel",
  componentId: "sc-1rx0r8w-1"
})(["font-size:12px;", ""], ({
  vertical
}) => !vertical && css(["width:22%;padding-right:10px;text-align:right;"]));
const Content = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "Content",
  componentId: "sc-1rx0r8w-2"
})(["width:78%;padding:0 15px;gap:10px;"]);
export default function Label({
  text,
  children,
  vertical
}) {
  return /*#__PURE__*/React.createElement(Root, {
    vertical: vertical
  }, text && /*#__PURE__*/React.createElement(StyledLabel, {
    vertical: vertical
  }, text), /*#__PURE__*/React.createElement(Content, null, children));
}
Label.displayName = "Label";
//# sourceMappingURL=index.js.map